import { Box, Heading, Text } from 'native-base'
import { Timer } from 'phosphor-react-native'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { useConfig } from '../../context/config'

export function LoggedOutHeader() {
  const { t } = useTranslation()
  const { config } = useConfig()

  return (
    <Box
      bgColor="bg"
      px={4}
      py={2}
      textAlign="center"
      borderRadius={8}
      display="flex"
      alignItems="center"
      flexDirection="column"
    >
      <Timer size={32} />
      <Heading color={'neutral.900'} fontSize="xl" mt={2}>
        {t('screens.welcome.loggedOut.heading')}
      </Heading>
      <Text mt={1} fontSize="md">
        {t('screens.welcome.loggedOut.text', { partner: config.partnerName, mins: config.patientSessionLengthInMins })}
      </Text>
    </Box>
  )
}
